export const SORT = "SORT";
export const PRICERANGE = "PRICE_RANGE"
export const RATING = "RATING";
export const CATEGORY = "CATEGORY";
export const CONDITION = "CONDITION"
export const CLEAN_UP = "CLEAN_UP";
export const SEARCH ="SEARCH"